export default __webpack_public_path__ + "static/media/0x1d734a02ef1e1f5886e66b0673b71af5b53ffa94.708ada34.webp";